<template>
  <div class="hgc_login">
    <div class="loginFormWrap">
      <form class="loginForm">
        <div class="logo">
          <img src="../../assets/img/Logo_Walbing.svg" />
        </div>
        <md-field :class="[{ 'md-error': errors.has('username') }]">
          <md-input
            v-model="form.username"
            type="email"
            required
            data-vv-name="username"
            v-validate="modelValidations.username"
            autocomplete="username"
          ></md-input>
          <label>{{ $t("common.email") }}</label> <!-- Must be after input for autofill fix -->
        </md-field>
        <md-field :class="[{ 'md-error': errors.has('password') }]">
          <md-input
            type="password"
            required
            v-model="form.password"
            data-vv-name="password"
            @keyup.enter="toLogin"
            v-validate="modelValidations.password"
            autocomplete="current-password"
          ></md-input>
          <label>{{ $t("common.password") }}</label> <!-- Must be after input for autofill fix -->
        </md-field>
        <div class="picValidata" v-if="showCaptcha">
          <md-field :class="[{ 'md-error': errors.has('captcha') }]">
            <label>{{ $t("common.captcha") }}</label>
            <md-input
              v-model="form.captcha"
              data-vv-name="captcha"
              required
              v-validate="modelValidations.captcha"
            ></md-input>
          </md-field>
          <div class="validateCode" v-loading="loading" @click="getChaUrl">
            <img :src="imgUrl" alt />
          </div>
        </div>
        <md-button
          class="md-primary md-bg"
          :class="[{ 'md-primary': canLogin }]"
          @click="toLogin"
        >{{$t('user.sendEmail.login')}}</md-button>
        <div class="otherBtns">
          <b class="signUp tertiary_color" @click="goSignUp">
            {{
            $t("user.sendEmail.signUp")
            }}
          </b>
          <span class="forgot secondary_color" @click="goSend">{{ $t("login.index.forgot") }}</span>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import {commonApi} from "@/common/api/commonApi";
import {userApi} from "@/common/api/userApi";
import {setToken} from "@/common/utils/auth"; // getToken from cookie
import APP from "@/common/appConfig";
import {mapActions} from "vuex";
import {navigationPaths} from "@/common/navigation/navigationPaths";

export default {
  data() {
    return {
      modelValidations: {
        password: {
          required: true
        },
        username: {
          required: true,
          email: true
        }
      },
      form: {
        password: "",
        username: "",
        captcha: ""
      },
      imgUrl: "",
      loading: false,
      showCaptcha: false
    };
  },
  mounted() {
    this.getChaUrl();
  },
  methods: {
    ...mapActions(["setActionLoggedIn"]),
    goSend() {
      this.$router.replace("/user/sendEmail");
    },
    getChaUrl() {
      this.loading = true;
      let url = APP.DOMAIN + "static/checkimg.jpg?" + moment().valueOf();
      this.imgUrl = url;
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    getToken() {
      return new Promise((resolve) => {
        commonApi.getToken().then(res => {
            setToken(res);
            resolve();
        }).catch(() => {
            resolve();
          });
      });
    },
    getCurrentUser() {
      return new Promise((resolve, reject) => {
        commonApi.Currentuser()
            .then(res => {
            let localUser = res.user;
            this.$sessionStorage.set("localeUser", JSON.stringify(localUser));

            if (res.user.userId > 0) {
              this.setActionLoggedIn(true);
            }

            resolve();
          })
            .catch(err => {
            this.toast(err);
            reject();
          });
      });
    },
    goSignUp() {
      this.$router.push(navigationPaths.register.base);
    },
    async toLogin() {
      if (this.canLogin) {
        this.getToken().then(this.getCurrentUser).then(this.doLogin);
      }
    },
    doLogin() {
      userApi
        .Login(this.form)
          .then(loginResult => {
          this.getToken()
            .then(this.getCurrentUser)
            .then(() => {
              if (loginResult.nextRouteVue) {
                    this.$router.replace(loginResult.nextRouteVue).then(this.reloadOnOutdatedVersion);
              } else {
                window.location.href = APP.DOMAIN + loginResult.nextResourceUrl;
              }
            });
        })
          .catch(err => {
          if (err.status === "LOGIN_OVER_TIMES") {
            this.showCaptcha = true;
            this.toast(err.msg);
          } else {
            this.toast(err);
          }
        });
    },
    reloadOnOutdatedVersion() {
      if (this.$store.state.base.version.outdated) {
        window.location.reload();
      }
    }
  },
  computed: {
    canLogin() {
      let can = false;
      if (
        this.form.password &&
        this.form.username &&
        !this.errors.has("password") &&
        !this.errors.has("username")
      ) {
        can = true;
      }
      if (this.showCaptcha) {
        if (!this.form.captcha) {
          can = false;
        } else {
          can = true;
        }
      }
      return can;
    }
    },
  components: {}
};
</script>

<style lang="scss" scoped>
@import "./login.scss";
</style>
